import React from 'react';

const DownloadAppButton = ({ appStoreLink, width = 200 }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <a
                href={appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View this app on the App Store"
                className="group relative inline-flex cursor-pointer rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
            >
                <img
                    src="/assets/apps/appstoreLogo.png"
                    alt="AppstoreLogo"
                    style={{ width: `${width}px`, objectFit: 'contain', textAlign: 'center' }}
                    className="pointer-events-none origin-bottom-right transition-transform duration-200 ease-out group-hover:scale-110 group-hover:rotate-3"
                />
            </a>
        </div>
    );
};

export default DownloadAppButton;
